import $ from "jquery";
import Vue from "vue";
import * as ers from "../../../errorsmessages/errors";
import * as suc from "../../../successmessages/success";
import * as rt from "../../../routes/routes";
import * as ses from "../../../configurations/session/sessioncomplete";
import baseurl from "../../../configurations/baseurl/baseurl";
import router from "../../../router/index";

export const actions = {
  newInterchange() {
    let interchangeDetails = {
      truck_id: $(".truck_id").val(),
      loading_date: $(".loading_date").val(),
      delivery: $(".delivery").val(),
      bond: $(".bond").val(),
      interchange: $(".interchange").val(),
      container_no: $(".container_no").val(),
      t1_status: $(".t1_status").val(),
      consignee: $(".consignee").val()
    };
    $(".creatingInterchange").hide();
    $(".creatingInterchangeLoader").show();
    baseurl.post(rt.newInterchange, interchangeDetails).then(res => {
      $(".creatingInterchange").show();
      $(".creatingInterchangeLoader").hide();
      $(".form-control").val("");

      //checking response codes from backend api

      if (res.data.code === 200) {
        //success codes
        suc.interchangesCreateSuccess();
        router.push("/manageinterchanges");
      } else if (res.data.code === 402) {
        //validation code
        ers.validateErrors();
      } else if (res.data.code === 403) {
        ers.InterchangeExists();
      } else if (res.data.code === 404) {
        ers.errorCreatingInterchanges();
      } else if (res.data.code === 405) {
        //no permission to create
        ers.noPermissionToCreate();
        router.push("/dashboard");
      } else if (res.data.code === 506) {
        //session expired
        ses.sessionComplete();
      }
    });
  },

  loadInterchanges({ commit }) {
    baseurl.get(rt.loadInterchanges).then(res => {
      $(".interchangesLoader").hide();

      //checking response codes

      if (res.data.code === 200) {
        //success code
        commit("STORE_INTERCHANGES", res.data.interchanges);
      } else if (res.data.code === 404) {
        //error on loading data
        ers.errorLoadingInterchanges();
      } else if (res.data.code === 405) {
        //no permission to read
        commit("STORE_TRUCKS", []);
        ers.noPermissionToRead();
        router.push("/dashboard");
      } else if (res.data.code === 506) {
        //session expired
        ses.sessionComplete();
      }
    });
  }
};
export default actions;


// WEBPACK FOOTER //
// ./src/vuex/modules/interchanges/actions.js